// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:940px){.input[data-v-6b231eee]{flex-direction:column}.input-elements[data-v-6b231eee]{flex-direction:row}.input-cnt[data-v-6b231eee]{margin-top:10px}.input-cnt[data-v-6b231eee]:first-child{margin:10px 0 0}.input__label[data-v-6b231eee]{line-height:40px;padding-top:10px;width:75px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
